module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('div', {
    staticClass: "p-sm-10-p"
  }, [_c('h3', {
    staticClass: "p-a-10 page-title"
  }, [_vm._v(_vm._s(_vm.activityInfo.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.info),
      expression: "activityInfo.info"
    }]
  }, [_c('div', {
    staticClass: "alert alert-info-bg"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.activityInfo.info)
    }
  })])])]), _vm._v(" "), (_vm.info.info.activity_id && _vm.activity.is_enable.value === 0 && !_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.enableOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.is_enable),
      callback: function($$v) {
        _vm.$set(_vm.activity, "is_enable", $$v)
      },
      expression: "activity.is_enable"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.ownerTypeOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "擁有者",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.owner_type),
      callback: function($$v) {
        _vm.$set(_vm.activity, "owner_type", $$v)
      },
      expression: "activity.owner_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType === 99 || (_vm.getRoleType === 30 && !_vm.info.info.activity_id)),
      expression: "getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.showWarning
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.enableOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label",
      "disabled": _vm.getRoleType !== 99
    },
    model: {
      value: (_vm.activity.is_platform_visible),
      callback: function($$v) {
        _vm.$set(_vm.activity, "is_platform_visible", $$v)
      },
      expression: "activity.is_platform_visible"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.showWarning
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.enableOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label",
      "disabled": _vm.getRoleType !== 99
    },
    model: {
      value: (_vm.activity.dedicated_visible_setting),
      callback: function($$v) {
        _vm.$set(_vm.activity, "dedicated_visible_setting", $$v)
      },
      expression: "activity.dedicated_visible_setting"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.description))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('br'), _vm._v(" "), _c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("活動時間設定")]), _vm._v(" "), _c('div', {
    staticClass: "broder-all"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.aTime.type),
      expression: "activity.aTime.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity.aTime, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("依據消費者下訂時間")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("依據消費者的下訂時間+預計取餐時間")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "p-x-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('date-time-picker', {
    staticClass: "w-100",
    attrs: {
      "date": _vm.activity.aTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "p-x-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('date-time-picker', {
    staticClass: "w-100",
    attrs: {
      "date": _vm.activity.aTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('br'), _vm._v(" "), _c('h4', [_vm._v("參與店家")]), _vm._v(" "), _c('div', _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(storeClass.name) + "\n                ")])])
  }), 0), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("週期/時段活動設定")]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addProcessTime
    }
  }, [_vm._v("新增某時段的製作時間")])]), _vm._v(" "), _vm._l((_vm.timeSettingList), function(process, pIndex) {
    return _c('div', {
      key: pIndex,
      staticClass: "m-t-10 process-time-block"
    }, [(pIndex !== 0) ? _c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.timeSettingList, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(13, true), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_vm._m(14, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.value_type),
        expression: "process.value_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "value_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearProcess(process)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("無指定")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("日期")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("星期")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(15, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(16, true), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.start_value),
        expression: "process.start_value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "日期(數字1~31)",
        "type": "text",
        "maxlength": "2"
      },
      domProps: {
        "value": (process.start_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(process, "start_value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(17, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(18, true), _vm._v(" "), _c('div', [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.end_value),
        expression: "process.end_value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "日期(數字1~31)",
        "type": "text",
        "maxlength": "2"
      },
      domProps: {
        "value": (process.end_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(process, "end_value", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(19, true), _vm._v(" "), _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.time_type),
        expression: "process.time_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "time_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeTimeType(process)
        }]
      }
    }, _vm._l((_vm.timeTypeOption), function(timeType) {
      return _c('option', {
        domProps: {
          "value": timeType.value
        }
      }, [_vm._v(_vm._s(timeType.label))])
    }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.time_type === 2) ? _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addItemTime(process)
        }
      }
    }, [_vm._v("加入時間")])]) : _vm._e(), _vm._v(" "), (process.time_type === 2) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(20, true), _vm._v(" "), _c('tbody', _vm._l((process.time_interval), function(item, iIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [(iIndex > 0) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(process.time_interval, iIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _vm._m(21), _vm._v(" "), (_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-left"
  }, [(_vm.activity.strategy_data.limit.order_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_types), function(orderType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_methods.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_methods), function(orderMethod) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderMethod.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.delivery_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.delivery_types), function(deliveryType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(deliveryType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.trade_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.trade_types), function(tradeType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(tradeType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]) : _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.orderType),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_types),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_types", $$v)
      },
      expression: "activity.strategy_data.limit.order_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.orderMethod),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_methods),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_methods", $$v)
      },
      expression: "activity.strategy_data.limit.order_methods"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.deliveryType),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.delivery_types),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "delivery_types", $$v)
      },
      expression: "activity.strategy_data.limit.delivery_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.tradeType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": _vm.getPlaceholder(_vm.tradeType),
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.trade_types),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "trade_types", $$v)
      },
      expression: "activity.strategy_data.limit.trade_types"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.info.info.has_used) ? _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.activity.strategy_data.limit.min_product_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_money) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_product_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_sub_order_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_product_money),
      expression: "activity.strategy_data.limit.min_product_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_product_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_product_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_product_amount),
      expression: "activity.strategy_data.limit.min_product_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_product_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_product_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_sub_order_amount),
      expression: "activity.strategy_data.limit.min_sub_order_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_sub_order_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_sub_order_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p form-center box-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("折扣規則")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataLimitOrderTypes),
      expression: "activityInfo.strategyDataLimitOrderTypes"
    }],
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataLimitOrderTypes))])])]), _vm._v(" "), (_vm.ruleCode === 'SD00001') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.amount_unit) + "\n                ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataSettingOneMaxDiscountTips))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "68px"
    }
  }, [_vm._v("\n                  最大折扣金額\n                ")]), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.one_max_discount) + "\n                ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.one_max_discount),
      expression: "activity.strategy_data.setting.one_max_discount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "無限制為空",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.one_max_discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "one_max_discount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(26), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.amount_unit))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.ratio))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.ratio),
      expression: "activity.strategy_data.setting.ratio"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.ratio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "ratio", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  商品限制最低單價\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingLowestUnitPriceTips),
      expression: "activityInfo.strategyDataSettingLowestUnitPriceTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingLowestUnitPriceTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.info.info.has_used) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.lowest_unit_price) + "\n                ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.lowest_unit_price),
      expression: "activity.strategy_data.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00004') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataSettingPercentValueTips))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(28), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.percent_value),
      expression: "activity.strategy_data.setting.percent_value"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.percent_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "percent_value", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activityInfo.strategyDataSettingRoundPolicyTips))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('div', {}, [_c('multiselect', {
    attrs: {
      "options": _vm.roundPolicy,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "折扣金額小數點進位方式",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.setting.round_policy),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.setting, "round_policy", $$v)
      },
      expression: "activity.strategy_data.setting.round_policy"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "145px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  是否忽略折讓金額(A+B)\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingIgnoreAllowanceTips),
      expression: "activityInfo.strategyDataSettingIgnoreAllowanceTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingIgnoreAllowanceTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('multiselect', {
    attrs: {
      "options": _vm.ignoreAllowance,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "是否忽略折讓(A+B)金額",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.setting.ignore_allowance),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.setting, "ignore_allowance", $$v)
      },
      expression: "activity.strategy_data.setting.ignore_allowance"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : (_vm.ruleCode === 'SD00005') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  買X份商品享折扣，X值(單位：份)\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingAmountUnitTips),
      expression: "activityInfo.strategyDataSettingAmountUnitTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingAmountUnitTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  折扣金額，Y值(單位：元)\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingDiscountUnitTips),
      expression: "activityInfo.strategyDataSettingDiscountUnitTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingDiscountUnitTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.discount_unit),
      expression: "activity.strategy_data.setting.discount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.discount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "discount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  商品限制最低單價\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityInfo.strategyDataSettingLowestUnitPriceTips),
      expression: "activityInfo.strategyDataSettingLowestUnitPriceTips"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.activityInfo.strategyDataSettingLowestUnitPriceTips
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.lowest_unit_price),
      expression: "activity.strategy_data.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.info.info.has_used) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SD00001' || _vm.ruleCode === 'SD00003' || _vm.ruleCode === 'SD00004' || _vm.ruleCode === 'SD00005') ? [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("排除商品選擇")]), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32)] : [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("折扣商品選擇")]), _vm._v(" "), _vm._m(33)]], 2) : _vm._e(), _vm._v(" "), (!_vm.info.info.has_used) ? _c('div', {}, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    style: (_vm.selectStorePadding)
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  選擇店家菜單\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.rule_code === 'SD00002'),
      expression: "this.$route.query.rule_code === 'SD00002'"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "擇一選擇門市並選取需折扣的商品。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.storeList,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "店家",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.ruleCode === 'SD00001' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SD00002' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '加入'
    },
    on: {
      "addProdToList": _vm.addProdToList
    }
  }) : (_vm.ruleCode === 'SD00004' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SD00005' && !_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (!_vm.info.info.has_used) ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length && (_vm.ruleCode === 'SD00001' || _vm.ruleCode === 'SD00004' || _vm.ruleCode === 'SD00005')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.$route.params.activity_id) ? _c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v(_vm._s(aProduct.vendor_custom_id))]) : _c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.store_exception_items[0].products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.product_info.length && _vm.ruleCode === 'SD00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td', [_vm._v("折扣規則")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.product_info), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.$route.params.activity_id) ? _c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v(_vm._s(aProduct.vendor_custom_id))]) : _c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_vm._v("\n                    購買  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (aProduct.amount_unit),
        expression: "aProduct.amount_unit"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (aProduct.amount_unit)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(aProduct, "amount_unit", $event.target.value)
        }
      }
    }), _vm._v("  個\n                    折  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (aProduct.discount),
        expression: "aProduct.discount"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (aProduct.discount)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(aProduct, "discount", $event.target.value)
        }
      }
    }), _vm._v("  元\n                      "), _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.sameItem(_vm.activity.strategy_data.setting.product_info, aIndex)
        }
      }
    }, [_vm._v("全部套用")])]) : _c('td', [_vm._v("\n                    購買  " + _vm._s(aProduct.amount_unit) + "  個\n                    折  " + _vm._s(aProduct.discount) + "  元\n                  ")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.setting.product_info, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.exception_products.length && _vm.ruleCode === 'SD00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.exception_products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.$route.params.activity_id) ? _c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v(_vm._s(aProduct.vendor_custom_id))]) : _c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), (!_vm.info.info.has_used) ? _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.setting.exception_products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), 0)])]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (_vm.info.info.activity_id) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkActivity
    }
  }, [_vm._v("\n      修改\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkActivity
    }
  }, [_vm._v("\n      新增\n    ")])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storeProdModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.curVCID) + " 出現的門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(34), _vm._v(" "), _c('tbody', _vm._l((_vm.storeProdList), function(sProd, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(aIndex + 1) + "\n              ")]), _vm._v(" "), _c('td', [(sProd.product_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.product_name) + " (" + _vm._s(sProd.product_id) + ")\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無對應的商品")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sProd.store_name))]), _vm._v(" "), _c('td', [(sProd.menu_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.menu_name) + "\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無使用中菜單")])])])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "warnModal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#warnModal"
    }
  }), _vm._v(" "), _vm._m(35)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right m-b-10"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-target": "#delModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" 活動已被使用，無法編輯限制規則、折扣規則，也無法刪除已參與店家 (可新增店家)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動啟用\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "45px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("擁有者\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("你訂平台\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon tip-icon-block",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  街口平台\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                活動說明\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "25px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動時間\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("可指定折扣活動時段：如週一到週三或每日14:00~16:00，若不指定可不需填寫")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("時間類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("時段設定\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-sm-10-p"
  }, [_c('div', [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("活動規則")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("若無特殊限制規則，可不進行異動")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', [_vm._v("訂單最低購買數量(單位：個)")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "若不限制可不填寫"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "訂單需達到最低金額門檻才會觸發活動，若不限制金額可不填寫"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', [_vm._v("訂單最低購買數量(單位：個)")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "若不限制可不填寫"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                  折扣滿足總數 (買X送一\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "60px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折扣滿足總數 (買X送Y，X數值)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "60px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折扣贈送總數 (買X送Y，Y數值)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  折數設定\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "138px"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                  折扣金額小數點進位方式\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("若有塑膠袋等，記得勾選。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("如排除商品為部分門市限定上架，需使用選擇參與店家找到該門市後再點選排除。 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('div', {
    staticClass: "alert alert-info-bg"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("請注意：先選擇完店家菜單後，再選擇要"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("排除")]), _vm._v("的商品")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-15"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("擇一選擇門市並選取需折扣的商品。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品 (ID)")]), _vm._v(" "), _c('td', [_vm._v("門市")]), _vm._v(" "), _c('td', [_vm._v("菜單")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "warnModal",
      "aria-hidden": "true",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "box-body form p-x-0"
  }, [_c('div', [_vm._v("\n              如欲調整揭露平台，請按右上角聯絡客服\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413321c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Discount/Temp/DiscountForm.vue
// module id = 2392
// module chunks = 1